/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { useNavigate } from 'react-router';
import { useStore } from '../store';
import './hot-topic-section.less';
interface IHotTopicProps {
  HotTopicSections: any;
}

const HotTopicSection: React.FunctionComponent<IHotTopicProps> = ({
  HotTopicSections,
}) => {
  const navigate = useNavigate();
  const { language } = useStore();
  const getImg = (img: string) => require(`../../../assets/${img}`).default;
  const gotoCoursePage = (hottopic: string) => {
    navigate(`/${language}/hottopic/${hottopic}`);
  };

  return (
    <div
      className={`hot-topic-section ${HotTopicSections.title
        .split(' ')
        .join('')}`}
      style={{ backgroundColor: HotTopicSections.color }}
    >
      <img
        className="hot-topic-img"
        src={HotTopicSections.pic && getImg(HotTopicSections.pic)}
        alt=""
      />
      <div
        className="hot-topic-content"
        style={{
          color: HotTopicSections.contentColor,
        }}
      >
        <p className="hot-topic-title">{HotTopicSections.title}</p>
        <p className="hot-topic-description">{HotTopicSections.description}</p>
        <div
          className="hot-topic-start-button"
          style={{
            borderColor: HotTopicSections.buttonColor,
            color: HotTopicSections.buttonColor,
          }}
          onClick={() => gotoCoursePage(HotTopicSections.page)}
        >
          <span>{HotTopicSections.button}</span>
        </div>
      </div>
    </div>
  );
};

export default HotTopicSection;
